import { isArrayNotEmpty, selectedGroup, isAgePassing } from './utils';
import { stringOrNumber, Groups, Selected, Errors } from './types';

const ageStrictedErrors = (
  groups: Groups,
  selected: Selected,
  groupId: stringOrNumber,
): Errors => {
  if (!isArrayNotEmpty(selected)) return [];

  if (isArrayNotEmpty(groups) && groupId) {
    const group = selectedGroup(groups, groupId);

    if (!group) return [];
    if (!group.age_strict) return [];

    return selected.reduce((result, { birthday, id, fio }) => {
      !isAgePassing(group, birthday) &&
        result.push({
          kid_id: id,
          error: `К сожалению, ${
            fio.split(' ', 2)[1]
          } по возрасту не подходит для обучения в группе.`,
        });
      return result;
    }, [] as Errors);
  }

  return [];
};

const ageStrictService = {
  ageStrictedErrors,
};

export default ageStrictService;



// WEBPACK FOOTER //
// ./src/services/agestrict/ageStrictService.ts